var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data && _vm.data.access > '')?_c('span',[_c('i',{staticClass:"fad fa-lock"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }